import { render } from "./ExportSapComponent.vue?vue&type=template&id=42fc605d&scoped=true"
import script from "./ExportSapComponent.vue?vue&type=script&lang=js"
export * from "./ExportSapComponent.vue?vue&type=script&lang=js"

import "./ExportSapComponent.vue?vue&type=style&index=0&id=42fc605d&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fc605d"]])

export default __exports__